/* eslint-disable */
import color from "constants/color";
import materialUI from "material-UI";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  padding: 0 15.67px 0 15.67px;
`;

export const Input = styled(materialUI.TextField)`
  margin-top: 2px;
  width: 100%;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    height: 44px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 4.5px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: ${color.primary} !important;
    }
  }
`;

export const PositionIcon = styled(materialUI.InputAdornment)``;

export const BtnSearch = styled(materialUI.Button)`
  height: 36px;
  width: 36px;
  min-width: auto;
  padding: 0;
  background: transparent;
  box-shadow: none;
  border: none;

  &:hover {
    background: transparent;
    box-shadow: none;
    border: none;
  }

  &.Mui-disabled {
    background: transparent;
    box-shadow: none;
    border: none;
  }
`;
